import { ButtonType, CheckBoxWithLabelWidget, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogType, FilteringList, ListItem, TabStyles } from '@tableau/widgets';
import { standardItemFilter } from '@tableau/widgets/lib/src/widgets/List/ListItemUtils'; // FIXME deep-importing like this is fragile and bad
import * as React from 'react';
import { Messages } from '../../codegen/Localize';
import { ReactModalOptions } from '../../commonInfra/dialogs/ReactModalService';

export interface RunNowEnabledSiteDialogProps {
    runNowEnabledStates: {
        [site: string]: boolean;
    };
    updateSites: (newState: { [site: string]: boolean }) => void;
    updateAll: (state: boolean) => void;
    close: () => void;
}

export interface RunNowEnabledSiteDialogState {
    runNowEnabledStates: {
        [site: string]: boolean;
    };
    filterText: string;
}

export class RunNowEnabledSiteDialog extends React.Component<RunNowEnabledSiteDialogProps, RunNowEnabledSiteDialogState> {
    private siteSettingToCheckbox(site: string, state: boolean): ListItem {
        return {
            value: site,
            content: < CheckBoxWithLabelWidget
                label={site}
                checked={state}
                testId={'site-runnow-setting-' + site}
                handleChange={(checked: boolean) => {
                    this.setState({
                        runNowEnabledStates: {
                            ...(!!this.state && this.state.runNowEnabledStates),
                            [site]: checked,
                        }
                    });
                }}
            />
        };
    }

    private checkboxes(siteStates: { [site: string]: boolean }): ListItem[] {
        return Object.keys(siteStates).map(site =>
            this.siteSettingToCheckbox(site, siteStates[site])
        );
    }


    constructor(props: RunNowEnabledSiteDialogProps) {
        super(props);
        this.state = {
            runNowEnabledStates: props.runNowEnabledStates,
            filterText: '',
        };
        this.siteSettingToCheckbox = this.siteSettingToCheckbox.bind(this);
    }

    render(): React.ReactNode {
        const checkboxes = this.checkboxes(this.state.runNowEnabledStates);
        const filteredCheckboxes = standardItemFilter(checkboxes, this.state.filterText);
        const siteStates = filteredCheckboxes.map(item => this.state.runNowEnabledStates[item.value]);
        const allFilteredSitesChecked = !siteStates.includes(false);
        const allFilteredSitesUnchecked = !siteStates.includes(true);
        const renderedItems = filteredCheckboxes.length > 0
            ? filteredCheckboxes
            : [{ value: Messages.runNowSiteNotFound(), disabled: true }];
        return <>
            <CheckBoxWithLabelWidget
                label={allFilteredSitesChecked
                    ? Messages.runNowSiteSelectionDialogDisableAll()
                    : Messages.runNowSiteSelectionDialogEnableAll()}
                checked={allFilteredSitesChecked}
                indeterminate={!allFilteredSitesChecked && !allFilteredSitesUnchecked}
                disabled={siteStates.length === 0}
                testId="all-sites-runnnow-setting"
                handleChange={(checked: boolean) => {
                    const newState: { [site: string]: boolean } = {};
                    filteredCheckboxes.forEach(item => {
                        const site = item.value;
                        newState[site] = checked;
                    });
                    this.setState({
                        runNowEnabledStates: {
                            ...this.state.runNowEnabledStates,
                            ...newState,
                        },
                    });
                }}
            />
            <FilteringList
                items={renderedItems}
                style={{
                    border: `1px solid ${TabStyles!.Colors!.L6}`,
                    maxHeight: '200px',
                }}
                searchText={this.state.filterText}
                testId="site-selection-list"
                onFilterChange={filterText => this.setState({ filterText, })}
                onSelect={(site: string) => this.setState({
                    runNowEnabledStates: {
                        ...(!!this.state && this.state.runNowEnabledStates),
                        [site]: !this.state.runNowEnabledStates[site],
                    }
                })}
            />
            <div style={{ paddingTop: '9px' }}>{siteStates.length} Sites, {siteStates.filter(b => b).length} selected</div>
            <div>
                <DialogFooterButtonsWidget
                    buttons={[{
                        handleClick: () => {
                            this.props.close();
                        },
                        buttonType: ButtonType.Grey,
                        children: Messages.runNowSiteSelectionDialogCancel(),
                        testId: 'footer-cancel'
                    }, {
                        handleClick: () => {
                            // Update the site settings
                            this.props.updateSites(this.state.runNowEnabledStates);
                            this.props.close();
                        },
                        buttonType: ButtonType.Go,
                        children: Messages.runNowSiteSelectionDialogSave(),
                        testId: 'footer-save'
                    }]}
                    testId="footer"
                />
            </div>
        </>;
    }
}

export function runNowEnabledSiteDialogProps(props: RunNowEnabledSiteDialogProps): ReactModalOptions {
    return {
        title: Messages.runNowSiteSelectionDialogTitle(),
        testId: 'run-now-enabled-site-dialog',
        type: DialogType.NormalWithTitleBar,
        positioningBehavior: DialogPositioningBehavior.Centered,
        dialogContent: <RunNowEnabledSiteDialog {...props} />,
    };
}
